import React from "react";
import MediaCardSection4 from "./MediaCardSection4";
import MediaCard1Section4 from "./MediaCard1Section4";
import media1 from "../../../images/galleryimage/media1.jpeg"
import media2 from "../../../images/galleryimage/media2.jpeg"
import media3 from "../../../images/galleryimage/media3.jpeg"
import media4 from "../../../images/galleryimage/media4.jpeg"
import media5 from "../../../images/galleryimage/media5.jpeg"
import media6 from "../../../images/galleryimage/media6.jpeg"

const MediaGallerySection4 = () => {
  return (
    <div id="media">
      <div className="mx-9 mt-24 flex overflow-hidden pb-12 lg:mx-48 lg:mt-44 ">
        <div className="lg:mt-20 ">
          <h1 className="">
            <ul className="">
              <li className="font-serif text-7xl text-blue-700">G</li>
              <li className="text-right text-2xl font-black lg:mt-10">A</li>
              <li className="text-2xl font-black lg:mt-10">L</li>
              <li className="text-right text-2xl font-black lg:mt-10">L</li>
              <li className="text-2xl font-black lg:mt-10">E</li>
              <li className="text-right text-2xl font-black lg:mt-10">R</li>
              <li className="text-2xl font-black lg:mt-10">Y</li>
            </ul>
          </h1>
        </div>
        <div className="container mt-6  lg:ml-9 ">
          <div className="flex h-[32vh] flex-wrap w-full mx-7">
            <div className=" w-[45%] flex-wrap ">
              <MediaCardSection4  image={media1}/>
              <MediaCardSection4 image={media2}/>
              <MediaCard1Section4 image1={media3}/>
            </div>
            <div className=" w-[45%] flex-wrap">
              <MediaCard1Section4 image1={media4} />
              <MediaCardSection4 image={media5}/>
              <MediaCardSection4  image={media6}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaGallerySection4;
